export default __webpack_public_path__ + "static/media/checkmark.d866694a.svg";